module.exports = __webpack_public_path__ + "static/media/195.5a98c806.svg";